module.exports = __webpack_public_path__ + "img/users.3169d843.svg";